import { useMemo } from 'react';
import { useSearchParams as useRivalSearchParams } from '@funtech-int/rival-react';

export function useSearchParams(): URLSearchParams {
    const searchParams = useRivalSearchParams();
    return useMemo(() => searchParams ?? new URLSearchParams(), [searchParams]);
}
